import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useChartData } from '../../../context/ChartContext';
import { HighlightEventSource, useHighlight } from '../../../highlight';
import { SpectrumPhaseTrace } from './SpectrumPhaseTrace';
import { useActivePhaseTraces } from './useActivePhaseTraces';
const BOX_SIZE = 20;
const style = css `
  fill: transparent;

  &:hover {
    fill: #ff6f0057;
  }
`;
export function SpectraPhaseTraces() {
    const { spectra = [], color, activeTraceDirection } = useActivePhaseTraces();
    return spectra.map((spectrumTrace) => {
        return (_jsx(PhaseTrace, { spectrum: spectrumTrace, color: color, direction: activeTraceDirection }, spectrumTrace.id));
    });
}
function PhaseTrace(props) {
    const { width, height, margin } = useChartData();
    const { spectrum: { x, y, id }, direction, } = props;
    const highligh = useHighlight([id], {
        type: HighlightEventSource.PHASE_CORRECTION_TRACE,
        extra: { id },
    });
    const innerHeight = height - margin.top - margin.bottom;
    const innerWidth = width - margin.left - margin.right;
    const transformY = innerHeight - BOX_SIZE / 2;
    const transformX = innerWidth - BOX_SIZE / 2;
    return (_jsxs(SpectrumPhaseTrace, { positionUnit: "PPM", position: { x, y }, ...highligh.onHover, children: [direction === 'horizontal' && (_jsx("rect", { css: style, y: transformY, x: margin.left, width: `${innerWidth}px`, height: `${BOX_SIZE}px` })), direction === 'vertical' && (_jsx("rect", { css: style, y: margin.top, x: transformX, width: `${BOX_SIZE}px`, height: innerHeight }))] }));
}
